<mat-tab-group animationDuration="0ms" [selectedIndex]="0" class="sub-tab-xdr"
               (selectedTabChange)="selectedTabChange($event)">

    <mat-tab label="Current"></mat-tab>
    <mat-tab label="Last 4 Hrs"></mat-tab>
    <mat-tab label="Last 24 Hrs"></mat-tab>
    <mat-tab label="Last 7 Days"></mat-tab>
    <mat-tab label="This Month"></mat-tab>
    <mat-tab label="Last Month"></mat-tab>

</mat-tab-group>


<div class="charts-grid">

  <app-bar-graph 
    title="DNSWatch Top Domains (query)"
    [state]="dnswatchState"
    [data]="dnswatchData">
  </app-bar-graph>

  <app-bar-graph 
    title="Attack Top Destination IPs"
    [state]="attackState"
    [data]="attackData">
  </app-bar-graph>

  <app-bar-graph 
    title="GeoIP Top Destination IPs"
    [state]="geoipState"
    [data]="geoipData">
  </app-bar-graph>

  <app-bar-graph 
    title="SPAM Top Destination IPs"
    [state]="spamState"
    [data]="spamData">
  </app-bar-graph>

</div>
